"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreferencesSuccessActionWatcher = exports.resetAllPreferencesActionWatcher = exports.initAccountPreferencesActionWatcher = exports.upsertAccountsSuccessActionWatcher = exports.getAccountsSuccessActionWatcher = exports.initAccountPreferences = exports.resetAllPreferences = void 0;
/*
 * PREFERENCE STORE SAGAS
 *
 * These routines listen for request actions, and satisfies them.  These are asynchronous routines, and upon
 * completion will dispatch a new action with the results
 *
 *
 */
const immutable_1 = require("immutable");
const effects_1 = require("redux-saga/effects");
const core_1 = require("companion-app-components/utils/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const preferences_1 = require("companion-app-components/flux/preferences");
const defaults_1 = require("data/preferences/defaults");
const axiosFactory_1 = __importDefault(require("utils/axiosFactory"));
const transactionsConfig_1 = require("components/TransactionRegister/transactionsConfig");
const log = (0, core_1.getLogger)('data/preferences/sagas.ts');
function* resetAllPreferences() {
    try {
        const qcsAxios = axiosFactory_1.default.get('qcs');
        const data = {
            section: 'shared',
            group: 'dataset',
            preference: null,
        };
        // first set redux prefs to defaults with a faux response
        yield (0, effects_1.put)(preferences_1.preferencesActions.setPreferenceSuccess({
            // @ts-expect-error: Object literal may only specify known properties, and 'data' does not exist in type 
            data,
            response: { data: defaults_1.defaultDatasetPreferences },
        }));
        // now null out the prefs on QCS
        // @ts-expect-error:Property 'constructPreferencesUrl' does not exist on type '(() => Generator<ForkEffect<never>, void, unknown>)[]'
        const requestUrl = preferences_1.preferencesSagas.constructPreferencesUrl(data);
        yield (0, effects_1.call)(qcsAxios.put, requestUrl, { webApp: null }, data.group === 'user' && { headers: { 'qcs-dataset-id': null } });
    }
    catch (error) {
        assert(false, error);
        log.log('Error in resetting preferences');
    }
}
exports.resetAllPreferences = resetAllPreferences;
// ====================================================
// INIT ACCOUNT PREFERENCES
function* initAccountPreferences() {
    const accountsPending = yield (0, effects_1.select)(accounts_1.accountsSelectors.getLoadPending);
    const prefsPending = yield (0, effects_1.select)(preferences_1.preferencesSelectors.getLoadPendingState);
    if (!accountsPending && !prefsPending.shared.dataset) {
        const accounts = yield (0, effects_1.select)(accounts_1.accountsSelectors.getAccountsById);
        const acctPrefs = yield (0, effects_1.select)(preferences_1.preferencesSelectors.allAccountPreferences);
        if (accounts) {
            const newAcctPrefs = preferences_1.preferencesUtils.initAccountPrefs(accounts, acctPrefs);
            if (newAcctPrefs) {
                const prefObj = {
                    section: 'shared',
                    group: 'dataset',
                    preference: { webApp: { accountsPrefs: newAcctPrefs } },
                };
                yield (0, effects_1.put)(preferences_1.preferencesActions.setPreference(prefObj, { context: 'initAccountPreferences1' }));
            }
        }
        //
        // Also check if the transaction columns config was updated with new defaults
        // if the required defaults in the code contain any columns NOT in the registerPrefs, then
        // add required defaults in
        //
        const prefs = yield (0, effects_1.select)(preferences_1.preferencesSelectors.getSharedPreferencesByPath, { group: 'dataset', path: ['webApp'] });
        const buildRegFields = (regFields, regFieldsDefault) => {
            let newRegFields = regFields || (0, immutable_1.List)();
            regFieldsDefault === null || regFieldsDefault === void 0 ? void 0 : regFieldsDefault.forEach((col) => {
                if (!newRegFields.includes(col)) {
                    const slot = newRegFields.findIndex((x) => transactionsConfig_1.fieldData[x].position > transactionsConfig_1.fieldData[col].position);
                    newRegFields = newRegFields.insert(slot, col);
                }
            });
            return newRegFields;
        };
        const regFieldsCashFlow = prefs.transactionRegister.regFieldsSort.cashFlow;
        const newFieldsCashFlow = buildRegFields(regFieldsCashFlow, transactionsConfig_1.requiredColumns.default);
        const regFieldsInvestment = prefs.transactionRegister.regFieldsSort.investment;
        // @ts-expect-error: Property 'investment' does not exist on type '{ default: string[]; }'.
        const newRegFieldsInvestment = buildRegFields(regFieldsInvestment, transactionsConfig_1.requiredColumns.investment);
        if (newFieldsCashFlow !== regFieldsCashFlow || newRegFieldsInvestment !== regFieldsInvestment) {
            const prefObj = {
                section: 'shared',
                group: 'dataset',
                preference: { webApp: { transactionRegister: { regFieldsSort: {
                                cashFlow: newFieldsCashFlow,
                                investment: newRegFieldsInvestment,
                            } } } },
            };
            yield (0, effects_1.put)(preferences_1.preferencesActions.setPreference(prefObj, { context: 'initAccountPreferences2' }));
        }
    }
}
exports.initAccountPreferences = initAccountPreferences;
function* getAccountsSuccessActionWatcher() {
    yield (0, effects_1.takeEvery)(accounts_1.accountsActions.getAccountsSuccess, initAccountPreferences);
}
exports.getAccountsSuccessActionWatcher = getAccountsSuccessActionWatcher;
function* upsertAccountsSuccessActionWatcher() {
    yield (0, effects_1.takeEvery)(accounts_1.accountsActions.batchAccountsSuccess, initAccountPreferences);
}
exports.upsertAccountsSuccessActionWatcher = upsertAccountsSuccessActionWatcher;
function* initAccountPreferencesActionWatcher() {
    yield (0, effects_1.takeEvery)(preferences_1.preferencesActions.initAccountPreferences, initAccountPreferences);
}
exports.initAccountPreferencesActionWatcher = initAccountPreferencesActionWatcher;
function* resetAllPreferencesActionWatcher() {
    yield (0, effects_1.takeEvery)(preferences_1.preferencesActions.resetAllPreferences, resetAllPreferences);
}
exports.resetAllPreferencesActionWatcher = resetAllPreferencesActionWatcher;
function* getPreferencesSuccessActionWatcher() {
    yield (0, effects_1.takeEvery)(preferences_1.preferencesActions.getPreferencesSuccess, initAccountPreferences);
}
exports.getPreferencesSuccessActionWatcher = getPreferencesSuccessActionWatcher;
exports.default = [
    getAccountsSuccessActionWatcher,
    getPreferencesSuccessActionWatcher,
    initAccountPreferencesActionWatcher,
    resetAllPreferencesActionWatcher,
    upsertAccountsSuccessActionWatcher,
];
